import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { metadataService } from "../../_services";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse
} from "reactstrap";
import { SlBusyIndicator } from "../editors";
import { BsDownload } from "react-icons/bs";
import { AiOutlineBook, AiFillCaretRight } from "react-icons/ai";
function DocumentCustomerDetails({
  source = [],
  labelTitle,
  notFoundMessage,
  isBusy,
  viewDocument,
  downloadDocument,
  ...props }) {

  const [isCollapsed, setIsCollapsed] = useState(false);
  useEffect(() => {
    if (isBusy === false) {
      setIsCollapsed(true);
    }
  }, [isBusy])
  const toggle = (e) => {
    setIsCollapsed(!isCollapsed);
  }
  return <Card>
    <CardHeader
      className="documents-card-header"
      onClick={toggle}
    >
      {metadataService.getLabel(labelTitle)}
      <div
        className={`${isCollapsed === true
          ? "isRotated left-align"
          : "left-align"
          }`}
      >
        {isBusy ? (
          <SlBusyIndicator visible={isBusy} />
        ) : (
          <AiFillCaretRight />
        )}
      </div>
    </CardHeader>
    <Collapse isOpen={isCollapsed}>
      {source.length === 0 ? (
        <CardBody>
          <div> {metadataService.getMessage(notFoundMessage)}</div>
        </CardBody>
      ) : (
        source.map(
          (doc) => (
            <CardBody
              key={doc.id}
              className={
                doc.isViewed
                  ? "my-document-card-body-visited"
                  : "my-document-card-body"
              }
            >
              <Row>
                <Col
                  style={{ paddingTop: "8px" }}
                  xs={10}
                  onClick={() => viewDocument(doc)}
                >
                  <div className="document-body-container">
                    <div className="document-file-info">
                      <span className="document-span-margin">
                        <AiOutlineBook size={25} />
                      </span>
                      <span className="document-span-margin">
                        {doc.displayFileName +
                          " - " +
                          moment(doc.creationTime).format("l")}
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs={2}>
                  <div
                    className="UploadButton"
                    onClick={() => downloadDocument(doc)}
                  >
                    <BsDownload size={20} />
                  </div>
                </Col>
              </Row>
            </CardBody>
          )
        )
      )}
    </Collapse>
  </Card>
}
DocumentCustomerDetails.propTypes = {
  dataSource: PropTypes.array,
  viewDocument: PropTypes.func,
  downloadDocument: PropTypes.func,
  isBusy: PropTypes.bool,
  labelTitle: PropTypes.string,
  notFoundMessage: PropTypes.string,
};
const mapStateToProps = (state) => {
  const { language } = state.users;
  return { language };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(DocumentCustomerDetails);



// WEBPACK FOOTER //
// ./src/components/subcomponents/DocumentCustomerDetails.jsx